import { useEffect, useState } from "react";
import { useGlobalContext } from "../../context";
import "./payment.css"
import { Accordion } from 'rsuite';
import 'rsuite/Accordion/styles/index.css';

function Payment(props) {
    const { setRoute } = useGlobalContext()
    useEffect(() => {
        setRoute(props.route)
    }, [])
    const [paymentPlatform, setPaymentPlatform] = useState([
        { id: 0, text: "زرین پال", img: "../../images/zarinpal.png", checked: true },
        { id: 1, text: "ملت", img: "../../images/bank-melat.jpg", checked: false },
        { id: 2, text: "آی دی پی", img: "../../images/idPay.png", checked: false },
    ])
    const handleBlob = (id) => {
        let update = paymentPlatform.map((item) => {
            if(item.id == id) {
                return {...item , checked : true}
            }else{
                return {...item , checked : false}
            }
        })
        setPaymentPlatform(update)
    }
    return (
        <div className="payment">
            <div className="payment-container">
                <div className="off-code">
                    <Accordion>
                        <Accordion.Panel style={{ direction: "rtl" }} header="اعمال کد تخفیف">
                            <span>کد تخفیف : </span>
                            <input className="inp-off" type="text" />
                            <button className="sub-off">اعمال</button>
                        </Accordion.Panel>
                    </Accordion>
                </div>
                    <h3 className="payment-title">درگاه پرداخت خود را انتخاب کنید</h3>
                <div className="payment-platform">
                    {
                        paymentPlatform.map((item, i) => {
                            return (
                                <div className="card" onClick={() => handleBlob(item.id)}>
                                    <div className="bg"></div>
                                    <div className={item.checked ? "blob active" :"blob"}></div>
                                    <img className="logo-payment" src={item.img} alt="" />
                                    <span className="name-payment">{item.text}</span>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default Payment;